var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTokenCircle = function SvgTokenCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M1.667 16C1.667 8.084 8.084 1.667 16 1.667S30.333 8.084 30.333 16 23.916 30.333 16 30.333 1.667 23.916 1.667 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    d: "M15.323 9.038a.803.803 0 0 1 1.354 0l.912 1.434a12.8 12.8 0 0 0 3.939 3.939l1.434.912a.803.803 0 0 1 0 1.354l-1.434.913a12.8 12.8 0 0 0-3.939 3.938l-.912 1.434a.803.803 0 0 1-1.354 0l-.913-1.434a12.8 12.8 0 0 0-3.938-3.939l-1.434-.912a.803.803 0 0 1 0-1.354l1.434-.912a12.8 12.8 0 0 0 3.938-3.94z"
  })));
};
export default SvgTokenCircle;